export default {
  homePara:
    "Language localisation is the process of adapting a product's translation to a specific country or region. It is the second phase of a larger process of product translation and cultural adaptation to account for differences in distinct markets, a process known as internationalisation and localisation.",
  aboutPara:
    "This tutorial is targetted to make localization simple. Though there are a lot of tutorials available on the internet. But, this one will teach you the concept in a simple manner. You can directly use this code for your software. I have used 'Rreact' hooks which is software industry standard now. You can follow my blog to get more UI related articles which will make you a better 'UI' developer. {0}",
  changeLanguage: "Select langauge",
  Libas_Tailor: "Libas Tailor",
  name: "Name",
  search_by: "Search by",
  orderNumber: "Order No",
  trackingNumber: "Tracking No",
  item: "Item",
  OrderDate: "Order Date",
  Qty: "Qty",
  delivery_date: "delivery Date",
  dynamicValue: "Dynamic Value- {randomNumber} {date}",
  Customer: "Customer",
  cloth_Items: "Cloth Item",
  //** Button */
  product_item: "PRODUCT ITEM",
  settings_product_measurement: "SETTINGS > PRODUCT MEASUREMENT",
  sms_balance: "SMS BALANCE",
  //** Home Page */
  add_new_order: "ADD NEW ORDER",
  add_new_customer: "ADD NEW CUSTOMER",
  add_customer_measurement: "ADD CUSTOMER MEASUREMENT",
  add_customer_order: "ADD CUSTOMER ORDER",
  edit_customer: "EDIT CUSTOMER",
  view_measurement: "VIEW MEASUREMENT",
  view_order: "VIEW ORDER",
  search_customers: "SEARCH CUSTOMERS",
  search_orders: "SEARCH ORDER",
  search_trackingNos: "SEARCH TRACKING NO",
  si: "SI",
  phone: "PHONE",
  order: "ORDERS",
  customer_name: "CUSTOMER NAME",
  order_date: "ORDER DATE",

  copy_right:
    "Copyright © Designed and Developed by '(01720944188) => jafarulla15@gmail.com'",

  qty: "QTY",
  note: "NOTE",
  Loading: "Loading",

  //** Button text */
  Remove: "Remove",
  Save: "Save",
  status: "Status",
  statusInfo: "Status Information",
  statusDetail: "Status Detail",
  statusDate: "Status Date",

  assignClothToTailor: "Assign Cloth To Tailor",
  getReadyCloth: "Get Ready Cloth",
  deliverToCustomer: "Deliver To Customer",

  //** Print Measurement */
  Customer_Name: "Customer Name",
  Tracking_NO: "Tracking NO",
  QTY: "QTY",
  NOTE: "NOTE",
  Phone: "Phone",
  Order_No: "Order No",

  //**** */
  Customer_Information: "Customer Information",



};
